<template>
  <!-- <v-container> -->
  <v-layout row wrap pa-3>
    <v-flex xs12>
      <v-card class="rounded">
        <v-card-text>
          <v-stepper v-model="e1">
            <v-stepper-header>
              <v-divider></v-divider>
              <v-stepper-step
                color="#d13b55"
                :complete="e1 > 1"
                :editable="$store.state.userProfileIsComplete"
                step="1"
                >Complete Profile</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step
                v-if="!$store.getters.isSuperAdmin"
                color="#d13b55"
                :complete="e1 > 2"
                :editable="$store.state.userProfileIsComplete"
                step="2"
                >Accept Organization Invitations</v-stepper-step
              >
              <v-divider></v-divider>

              <!-- <v-stepper-step
                :complete="e1 > 3"
                :editable="$store.state.userProfileIsComplete"
                step="3"
              >Create Organization</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step
                :complete="e1 > 4"
                :editable="$store.state.userProfileIsComplete"
                step="4"
              >Invite To Organization</v-stepper-step>
            <v-divider></v-divider>-->
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <!-- <v-card>
              <v-card-text>-->
                <ProfileInfo></ProfileInfo>
                <!-- </v-card-text>
              </v-card>-->
                <div class="mt-3">
                  <v-btn
                    class="btn-rounded-medium"
                    outline
                    color="success"
                    :disabled="!completeProfileContinueButtonVisiblity"
                    @click.prevent="profileContinue()"
                  >
                    Continue
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content v-if="!$store.getters.isSuperAdmin" step="2">
                <!-- <v-card>
              <v-card-text>-->
                <InvitesFromOrganizations></InvitesFromOrganizations>
                <!-- </v-card-text>
              </v-card>-->
                <div class="mt-3">
                  <v-btn
                    class="btn-rounded-medium"
                    color="secondary"
                    outline
                    @click.prevent="e1 = 1"
                    >Back</v-btn
                  >
                  <span class="px-2"></span>
                  <v-btn
                    class="btn-rounded-medium"
                    outline
                    color="success"
                    to="/dashboard"
                    >Finish</v-btn
                  >
                </div>
              </v-stepper-content>

              <!-- <v-stepper-content step="3">
                <v-card class="mb-5">
                  <CreateOrganization></CreateOrganization>
                </v-card>

                <v-btn flat outline @click="e1=2">Back</v-btn>
                <v-btn color="primary" @click="createOrganizationContinue()">Continue</v-btn>
            </v-stepper-content>-->

              <!-- <v-stepper-content step="4">
                <v-card class="mb-5">
                  <InviteToOrganization></InviteToOrganization>
                </v-card>

                <v-btn flat outline @click="e1=3">Back</v-btn>
                <v-btn color="primary" to="/dashboard">Finish</v-btn>
            </v-stepper-content>-->
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
  <!-- </v-container> -->
</template>

<script>
import router from "@/router";
import ProfileInfo from "@/components/ProfileInfo";
import CreateOrganization from "@/views/RegisterOrganization";
import InviteToOrganization from "@/views/InviteToOrganization";
import InvitesFromOrganizations from "@/views/InvitesFromOrganizations";

export default {
  name: "NewUserWizard",
  components: {
    ProfileInfo,
    CreateOrganization,
    InviteToOrganization,
    InvitesFromOrganizations,
  },
  data() {
    return {
      e1: 0,
      completeProfileContinueButtonVisiblity: false,
    };
  },
  watch: {
    // Watch for userDataIsComplete to change to true to enable continue button for user to move to next step.
    "$store.state.userDataIsComplete": function (value) {
      if (value) {
        this.completeProfileContinueButtonVisiblity = true;
      }
    },
  },
  methods: {
    profileContinue() {
      if (this.$store.state.userDataIsComplete) {
        if (this.$store.getters.isSuperAdmin) {
          router.replace("addfunds");
        } else {
          this.e1 = 2;
        }
      } else {
        // Display Error Message
        this.$store.commit("replaceSnackbar", {
          message: "Error: Your profile is NOT complete, please complete.",
          messageType: "error",
        });
      }
    },
    createOrganizationContinue() {
      // Only allow stepping forward if user profile is complete (ie. user has an activeOrg)
      if (this.$store.state.userProfileIsComplete) {
        this.e1 = 4;
      } else {
        // Display Error Message
        this.$store.commit("replaceSnackbar", {
          message:
            "Error.  You must be part of an Organization before continuing.",
          messageType: "error",
        });
      }
    },
  },
  beforeMount() {
    // initialize the profile complete continue button
    this.completeProfileContinueButtonVisiblity =
      this.$store.state.userDataIsComplete;
  },
};
</script>

<style scoped>
.container {
  padding-left: 0px !important;
}
</style>